import { render } from "./SendList.vue?vue&type=template&id=d451e1f2&scoped=true"
import script from "./SendList.vue?vue&type=script&lang=js"
export * from "./SendList.vue?vue&type=script&lang=js"

import "./SendList.vue?vue&type=style&index=0&id=d451e1f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d451e1f2"]])

export default __exports__